import React from 'react'


import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

function JoinProgramCard({ translate, onJoinProgram: handleJoinProgram = NOOP }) {
  return (
    <div className="status-card__join-card">
      <h5 className="status-card__join-title cgt-legacy-heading-h5">
        {translate('my_subscriptions.status_card.join_title')}
      </h5>

      <p className="status-card__join-description cgt-text-medium">
        {translate('my_subscriptions.status_card.join_description')}
      </p>

      <Button type="primary" onClick={handleJoinProgram} size="small" customClass="status-card__join-button">
        {translate('my_subscriptions.status_card.join_button')}
      </Button>
    </div>
  )
}

JoinProgramCard.propTypes = {
  translate: func.isRequired,
  onJoinProgram: func,
}

export default JoinProgramCard
